<template>
  <cms-custom-html
    :theme="theme"
    :is-preview="true"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';

defineOptions({
  name: 'ViewCustomCode',
});

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => ({
  ...mainStore.getTheme.containers[props.containerIdx].components[props.componentIdx].options,
  translations: translationStore.getComponentTranslation('custom_html'),
  globalThemeSettings: mainStore.getGlobalThemeSettings,
}));
</script>
